import React from "react";
import {
	styledSystem as ss,
	inputStyles,
	inputSizes,
	inputVariants,
	inputSelectStyles,
	theme,
} from ".";

export type ISelectProps = ss.ICommonProps &
	{
		block?: boolean;
		s?: "default" | "sm" | "lg" | "font";
		variant?: "contrast" | "dark" | "plain";
		options?: { [value: string]: string };
		withError?: boolean;
	}
;

// Basic select
export const StyledSelect = ss.styled.select<ISelectProps>`
	${inputStyles}
	${inputSelectStyles}
	${props => inputSizes[props.s || "default"]}
	${props => props.block ? { width: "100%", display: "block" } : undefined }
	${props => props.variant && inputVariants[props.variant] ? inputVariants[props.variant] : undefined}
	${props => props.variant === "dark" ? { filter: "grayscale(1) brightness(5)" } : undefined }
	${props => props.withError ? {borderColor: props.theme.colors.red[8]} : {}}
	${ss.COMMON}
`;

StyledSelect.defaultProps = {
	theme,
}

export const Select = ({options, ...props}: ISelectProps & Omit<JSX.IntrinsicElements["select"], "ref">) => {
	if (options) {
		const childs = Object.entries(options).map(([value, label]) => {
			return <option key={value} value={value}>{label}</option>;
		});
		return <StyledSelect {...props}>{childs}{props.children}</StyledSelect>;
	}
	return <StyledSelect {...props} />;
}

// Variants
export const SelectContrast = ss.styled(Select)``; SelectContrast.defaultProps = { variant: "contrast" };
export const SelectDark = ss.styled(Select)``; SelectDark.defaultProps = { variant: "dark" };
export const SelectPlain = ss.styled(Select)``; SelectPlain.defaultProps = { variant: "plain" };
